import { useCallback, useMemo } from 'react';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import { replaceSelectedNode } from '@atlassian/company-hub-common/controllers/editor-actions';
import type { UseExtensionParametersAndActionsProps } from '@atlassian/company-hub-common/items-shared/items-shared/types';

import { useHubElementPlaceholderExtensionsActions } from '../use-hub-element-placeholder-extensions';
import type { UseHubElementsParametersAndActionsReturnType } from './types';

export const useHubElementsPlaceholderActions = ({
	editorActions,
}: Pick<
	UseExtensionParametersAndActionsProps,
	'editorActions'
>): UseHubElementsParametersAndActionsReturnType => {
	const { setPreviewContentForHubElementPlaceholder } = useHubElementPlaceholderExtensionsActions();

	const replaceHubElementPlaceholderNode = useCallback(
		(nodeAdf: ADFEntity) => {
			replaceSelectedNode(editorActions, nodeAdf);
		},
		[editorActions],
	);

	const updatePreviewDetails = useCallback(
		(extensionLocalId: string, previewComponent: React.ReactNode) => {
			setPreviewContentForHubElementPlaceholder(extensionLocalId, previewComponent);
		},
		[setPreviewContentForHubElementPlaceholder],
	);

	const resetPreviewDetails = useCallback(() => {
		setPreviewContentForHubElementPlaceholder(null, null);
	}, [setPreviewContentForHubElementPlaceholder]);

	const hubElementPlaceholderActions = useMemo(() => {
		return {
			replaceHubElementPlaceholderNode,
			updatePreviewDetails,
			resetPreviewDetails,
		};
	}, [replaceHubElementPlaceholderNode, updatePreviewDetails, resetPreviewDetails]);

	return { hubElementPlaceholderActions };
};
